import React from 'react';
import { ISubModuleProps } from '../../types';
import { Link, getClassNameFactory } from '@dcl/ui';
import { LinkTypes } from '@dcl/ui/dist/elements/Link';
import { ModuleList } from '../../ModuleList';
import './SubModule.css';

const SubModule = ({ text, url, newTab }: ISubModuleProps) => {
  const getClassName = getClassNameFactory(ModuleList.displayName);
  return (
    <div className={getClassName({ descendantName: 'subModule' })}>
      <Link href={url} newWindow={newTab} type={LinkTypes.INLINE}>
        {text}
      </Link>
    </div>
  );
};
export default SubModule;
